import { DriveLugFactoryScreen } from '../pages/inspections/undercarriage/DriveLugFactoryScreen';
import { EngagementScreen } from '../pages/inspections/undercarriage/driveTumbler/EngagementScreen';
import { IdlerFactoryScreen } from '../pages/inspections/undercarriage/IdlerFactoryScreen';
import { UndercarriageRollerAssembliesTableOfContentsScreen } from '../pages/inspections/undercarriage/rollerAssemblies/RollerAssembliesTableOfContentsScreen';
import { RollerAssemblyScreen } from '../pages/inspections/undercarriage/rollerAssemblies/RollerAssemblyScreen';
import { RollerPathFactoryScreen } from '../pages/inspections/undercarriage/RollerPathFactoryScreen';
import { PitchExtensionScreen } from '../pages/inspections/undercarriage/shoes/PitchExtensionScreen';
import { SideFrameScreen } from '../pages/inspections/undercarriage/SideFrameScreen';
import { UndercarriageSideTableOfContentsScreen } from '../pages/UndercarriageSideTableOfContents';
import { UndercarriageTableOfContentsScreen } from '../pages/UndercarriageTableOfContentsScreen';
import { routePaths } from './basePaths';

export const undercarriagePaths = [
  {
    path: routePaths.InspectionBasePath + '/undercarriage',
    element: <UndercarriageTableOfContentsScreen />,
  },
  {
    path: routePaths.InspectionBasePath + '/undercarriage/:sideName',
    children: [
      {
        path: '',
        element: <UndercarriageSideTableOfContentsScreen />,
      },
      {
        path: 'side-frame',
        element: <SideFrameScreen />,
      },
      {
        path: 'idler/:side',
        element: <IdlerFactoryScreen />,
      },
      {
        path: ':partCategory',
        children: [
          {
            path: 'pitch-extension',
            element: <PitchExtensionScreen />,
          },
          {
            path: 'roller-path',
            element: <RollerPathFactoryScreen />,
          },
          {
            path: 'drive-lug',
            element: <DriveLugFactoryScreen />,
          },
          {
            path: 'load-rollers',
            element: (
              <UndercarriageRollerAssembliesTableOfContentsScreen
                partCategoryName="Roller"
                rollerName="Load Roller"
                headerTitle="Roller assemblies"
                subHeaderTitle="Load Rollers"
              />
            ),
          },
          {
            path: 'return-rollers',
            element: (
              <UndercarriageRollerAssembliesTableOfContentsScreen
                partCategoryName="Roller"
                rollerName="Return Roller"
                headerTitle="Roller assemblies"
                subHeaderTitle="Return Rollers"
              />
            ),
          },
          {
            path: 'sliders',
            element: (
              <UndercarriageRollerAssembliesTableOfContentsScreen
                partCategoryName="Slider"
                rollerName="Slider"
                headerTitle="Sliders"
                subHeaderTitle="Sliders"
              />
            ),
          },
          {
            path: ':partName/:equipmentPartId/:position',
            element: <RollerAssemblyScreen />,
          },
          {
            path: 'engagement',
            element: <EngagementScreen />,
          },
        ],
      },
    ],
  },
];
